<template>
  <van-pull-refresh v-model="isLoading" :disabled="reFlag" success-text="刷新成功" @refresh="onRefresh">
    <div>
      <router-view />
    </div>
  </van-pull-refresh>
</template>
<script>
import { Toast } from "vant";
import qs from "qs";
import "./assets/css/data_picker.css";

export default {
  name: "App",
  data() {
    return {
      isLoading: false,
      reFlag: false,
      name: "",
      sendStartObj: null,
      loginFlag: false,
    };
  },
  methods: {
    getUserInfo() {
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },
    onRefresh() {
      setTimeout(() => {
        window.location.reload(true);
        Toast({ message: "刷新成功", className: "toast" });
        this.isLoading = false;
      }, 1000);
    },
    sendLoginTime() {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time.getDate().toString().padStart(2, "0");
      var h = time.getHours().toString().padStart(2, "0");
      var mm = time.getMinutes().toString().padStart(2, "0");
      var s = time.getSeconds().toString().padStart(2, "0");
      var startTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      this.sendStartObj = {
        startDate: startTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: this.name,
      };
      this.$addr
        .post("Log/insert", qs.stringify(this.sendStartObj))
        .then((res) => {
          this.loginFlag = true;
        });
    },
  },
  mounted() {
    setTimeout(() => {
      Toast({ message: "页面支持下拉刷新", className: "toast" });
    }, 1000);
  },
  created() {
    this.getUserInfo();
    this.$router.beforeEach((to, from, next) => {
      this.sendStartObj = null;
      if (to.name == "IndexFiv") {
        this.reFlag = true;
        this.name = "Price Alert";
        this.sendLoginTime();
      } else if (to.name == "IndexFor") {
        this.name = "Industry Radar";
        this.sendLoginTime();
      } else if (to.name == "IndexSec") {
        this.name = "Sales Report";
        this.sendLoginTime();
      } else if (to.name == "IndexThr") {
        this.name = "EC-Pos Report";
        this.sendLoginTime();
      } else if (to.name == "Index") {
        this.name = "War Room";
        this.sendLoginTime();
      } else if (to.name == "Home") {
        this.name = "";
      }
        next();
    });
  },
};
</script>
<style>
.toast {
  background: rgba(209, 83, 75, 0.7);
}
html,
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;
  padding: 0;
}
body {
  font-family: Helvetica !important;
}
html,
body {
  min-height: 100%;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
}
ul,
ol {
  list-style: none;
}
img {
  border: none;
  vertical-align: middle;
}
a {
  text-decoration: none;
  color: #232323;
}
table {
  border-collapse: collapse;
  table-layout: fixed;
}
input,
textarea {
  outline: none;
  border: none;
}
textarea {
  resize: none;
  overflow: auto;
}
.clearfix {
  zoom: 1;
}
.clearfix:after {
  content: ".";
  width: 0;
  height: 0;
  visibility: hidden;
  display: block;
  clear: both;
  overflow: hidden;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.tl {
  text-align: left;
}
.tc {
  text-align: center;
}
.tr {
  text-align: right;
}
.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.inline {
  display: inline-block;
  *display: inline;
  *zoom: 1;
}
</style>



// WEBPACK FOOTER //
// src/App.vue